import { FC } from "react";

import { BarContainer, BarWrapper, Filler, FillerBackground } from "./style";

interface ProgressBarTypes {
  progress: number;
  isEmptyState: boolean;
}

const ProgressBar: FC<ProgressBarTypes> = ({ progress, isEmptyState }) => {
  const fillerRelativePercentage = (100 / progress) * 100;

  return (
    <BarWrapper
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={progress}
    >
      <BarContainer emptyState={isEmptyState}>
        <Filler width={progress}>
          <FillerBackground width={fillerRelativePercentage} />
        </Filler>
      </BarContainer>
    </BarWrapper>
  );
};
export default ProgressBar;
